import {
  UPDATE_CORPORATE_STATUS,
  UPDATE_CORPORATE_STATUS_SUCCESS,
  UPDATE_CORPORATE_STATUS_FAILURE,
} from "../actionTypes";

export const updateCorporateStatus = (payload) => ({
  type: UPDATE_CORPORATE_STATUS,
  payload,
});

export const updateCorporateStatusSuccess = (payload) => ({
  type: UPDATE_CORPORATE_STATUS_SUCCESS,
  payload,
});

export const updateCorporateStatusFailure = () => ({
  type: UPDATE_CORPORATE_STATUS_FAILURE,
});